import script from "./DropdownQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownQuestion.vue?vue&type=script&setup=true&lang=js"

import "./DropdownQuestion.vue?vue&type=style&index=0&id=7c2a778b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2a778b"]])

export default __exports__